Common.body = function () {
	let body = $(document.body);

	body = body.filter(':not(.scrolled)')

	if (body.length) {
		const $window = $(window);
		body.add($window).on('scroll', () => {
			if ((body.scrollTop() || $window.scrollTop()) > 200) body.addClass('is-scrolled')
			else body.removeClass('is-scrolled')
		})
	}
}
